import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';

export const TextCont = styled.div`
  display: flex;
  align-items: center;
  width: 432px;

  ${({ theme }: IThemeProvider) => `
    height: ${theme.layout.spacing.hekto};
    margin: ${theme.layout.spacing.centy} 0;
  `}
`;
